import React, { useEffect, useRef } from "react";
import "./ConfirmModal.css";

const ConfirmModal = ({
    isOpen,
    title,
    subtitle,
    onConfirm,
    onCancel,
    confirmText = "Confirm",
    cancelText = "Cancel",
    hideCancel = false,
    loading = false
}) => {
    const modalRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                onCancel();
            }
        };

        const handleEscapeKey = (event) => {
            if (event.key === "Escape") {
                onCancel();
            }
        };

        if (isOpen) {
            document.addEventListener("mousedown", handleClickOutside);
            document.addEventListener("keydown", handleEscapeKey);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
            document.removeEventListener("keydown", handleEscapeKey);
        };
    }, [isOpen, onCancel]);

    if (!isOpen) return null;

    return (
        <div className="modal-overlay">
            <div className="modal-container" ref={modalRef}>
                <h2 className="modal-title">{title}</h2>
                {subtitle && <p className="modal-subtitle">{subtitle}</p>}

                <div className="modal-buttons">
                    {!hideCancel && cancelText && (
                        <button className="button-cancel" onClick={onCancel}>
                            {cancelText}
                        </button>
                    )}
                    <button
                        className="button-confirm"
                        onClick={onConfirm}
                        disabled={loading}
                        style={{ display: onConfirm === 0 ? "none" : "inline-block" }}
                    >
                        {loading ? (
                            <span className="loading-content">
                                <span className="spinner" /> Loading...
                            </span>
                        ) : (
                            confirmText
                        )}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmModal;
